import { applyMiddleware, createStore } from 'redux'
import { createLogger } from 'redux-logger'
import createRootReducer from './reducers'
import { createBrowserHistory } from 'history'
import { routerMiddleware } from 'connected-react-router'
import createSagaMiddleware from 'redux-saga'
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import rootSaga from './sagas/index.saga'
import { composeWithDevTools } from 'redux-devtools-extension'
import { isDev } from '@/utils/enviroment'

const logger = createLogger({
    predicate: isDev,
    collapsed: true,
})

const persistConfig = {
    key: 'reducer',
    storage,
    // blacklist: ['TabbarReducer'] // navigation will not be persisted  黑名单
    whitelist: ['tableEditData', 'router', 'auth'] // only navigation will be persisted  白名单
}

export const history = createBrowserHistory()
const persistedReducer = persistReducer(persistConfig, createRootReducer(history))

const sagaMiddleware = createSagaMiddleware()

console.log('isDev: ', isDev())
const store = createStore(
    persistedReducer,
    // createRootReducer(history),
    isDev()
        ? composeWithDevTools(
            applyMiddleware(routerMiddleware(history), sagaMiddleware, logger)
        )
        : applyMiddleware(routerMiddleware(history), sagaMiddleware)
)

sagaMiddleware.run(rootSaga)
export const persistor = persistStore(store)
export default store
